import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { ProductShot } from './ProductShot';
import { needIsThere } from '../data/content';
export function HoursSection() {
  return <section className="border-y-4 border-cream-deep bg-white px-4 py-6 sm:px-6" data-id="element-94" data-mp="3oz67ixixyc6a">
      <SectionHeading size="lg" data-id="element-95" data-mp="3k4iqfjq9ok1q">
        ⏱️ Turn hours of searching &amp; planning into a ready-to-use system
      </SectionHeading>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-96" data-mp="3u0vgm7mlsfrq">
        Imagine opening one organized resource and having options for different
        situations.
      </p>

      <ul className="mx-auto mt-3 grid max-w-2xl gap-1 sm:grid-cols-2" data-id="element-97" data-mp="6okrvafdq5sc">
        {needIsThere.map(item => <li key={item.need} className="flex items-start gap-2 rounded bg-cream px-3 py-1.5" data-id="element-98" data-mp="llli19hx9sop">
            <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="gjw6ztup9f0m" />
            <p className="text-[12px] leading-snug sm:text-[13px]" data-id="element-100" data-mp="2ffdgmbxjafa4">
              <span className="font-semibold text-graphite" data-id="element-101" data-mp="2jfnwcgb4ok26">{item.need}</span>{' '}
              <span className="font-extrabold text-teal" data-id="element-102" data-mp="2of0iszy37p48">{item.answer}</span>
            </p>
          </li>)}
      </ul>

      <p className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-103" data-mp="2tf4y4mn9edsv">
        Not another collection of disconnected ideas.{' '}
        <strong className="font-bold text-navy" data-id="element-104" data-mp="334eq82i3rwgz">
          One practical system built around the activities you actually need to
          organize.
        </strong>{' '}
        That’s SENIOR ACTIVITY READY™.
      </p>

      <ProductShot size="md" className="my-4" data-id="element-105" data-mp="3c5mhi0m7bx1k" />

      <div className="mx-auto max-w-md" data-id="element-106" data-mp="3c2qjyde9nadn">
        <CTAButton tone="terracotta" data-id="element-107" data-mp="3h34r7t81mgam">
          👥 Yes! I want the complete system
        </CTAButton>
      </div>
    </section>;
}